import { VerbatimFilter } from 'components/UnifiedSearch/types';

export const VERBATIM_OPTIONS: { [key in VerbatimFilter]: string } = {
  all: 'All results',
  verbatim: 'Verbatim',
};
